import { Form as AntdForm, Row } from "antd";
import React from "react";

export default function FormLayout({
  gutter = 16,
  layout = "vertical",
  ...props
}) {
  return (
    <AntdForm gutter={gutter} layout={layout} component={Row} {...props} />
  );
}

const FormItem = ({
  htmlFor,
  label = "",
  error,
  required = false,
  ...props
}) => {
  return (
    <AntdForm.Item
      htmlFor={htmlFor}
      required={required}
      label={label}
      hasFeedback={true}
      validateStatus={error && error.type && "error"}
      help={error && error.message}
      {...props}
    />
  );
};

const FormSection = ({ title, actions = [], error, ...props }) => {
  return (
    <div {...props} className="form-section-wrapper">
      <span className="form-section-title">
        {title}
        {error ? (
          <span style={{ fontStyle: "italic", fontSize: 12 }}>{error}</span>
        ) : null}
        {actions.length > 0 ? (
          <div style={{ float: "right" }}>{actions.map((item) => item)}</div>
        ) : null}
      </span>

      <div className="form-section-body">{props.children}</div>
    </div>
  );
};

export { FormSection, FormItem };
